export default "__VITE_ASSET__CqeFfMGM__"